export const enClientPortalOrderListPagePages = {
    orders: {
        orderListPage: {
            newOrder: 'New order',
            tabs: {
                open: 'Open',
                closed: 'Completed',
                cancelled: 'Cancelled',
            },
            filters: {
                search: 'Search order',
                status: 'Status',
                valuationDateFrom: 'Valuation date from',
                valuationDateTo: 'Valuation date to',
                assignee: 'Assignee',
                assigneeOptionsLoading: 'Options are loading...',
                assigneeOptionsEmpty: 'No options available',
                resetAll: 'Reset all filters',
                sortAriaLabel: 'Sorting',
                sortTooltip: 'Sort orders',
                sortByOrderDate: 'By latest order date',
                sortAlphabetically: 'Alphabetically A-Z',
            },
            emptyStates: {
                noOpenOrders: 'No open orders available',
                showClosedOrders: 'Completed orders',
                noClosedOrders: 'No completed orders available',
                showCancelledOrders: 'Cancelled orders',
                noCancelledOrders: 'No cancelled orders available',
                showOpenOrders: 'Open orders',
                noFilteredOrders: 'No orders found for your selection',
                resetFilters: 'Reset filters',
            },
            snackbar: {
                observerSaved: 'Your changes were saved successfully',
            },
            cells: {
                assignee: 'Assignee',
                notSet: 'Not set',
                orderDate: 'Order date',
                valuationDateShort: 'Valuation date',
            },
            observer: {
                protected: 'As an order assignee, you automatically observe this order.',
                platformUser: 'As a platform user, you cannot add yourself as an observer.',
                observing: 'You are observing this order. Click to stop observing.',
                notObserving: 'You are not observing this order. Click to observe.',
            },
            plausibility: {
                draft: 'Draft',
                draftWithVersion: 'Draft {{version}}',
                annotationCount_one: '{{count}} annotation',
                annotationCount_other: '{{count}} annotations',
                goToPlausibility: 'To plausibility check',
                actions: 'Plausibility check actions',
                shareAnnotations: 'Share annotations',
                annotationsAlreadyShared: 'Annotations already shared',
                noAnnotations: 'No annotations available',
                fundApproveDraft: 'Fund: approve draft',
                kvgApproveDraft: 'CMC: approve draft',
                approveDraft: 'Approve draft',
                fundAlreadyApproved: 'Fund-side approval already granted',
                kvgAlreadyApproved: 'CMC-side approval already granted',
                draftAlreadyApproved: 'Draft already approved',
                approved: 'approved',
                shared: 'shared',
                fundLabel: 'Fund',
                kvgLabel: 'CMC',
                fundApprovalGranted: 'Fund approval granted',
                fundApprovalPending: 'Fund approval pending',
                kvgApprovalGranted: 'CMC approval granted',
                kvgApprovalPending: 'CMC approval pending',
                modal: {
                    cancel: 'Cancel',
                },
                appraiserSelection: {
                    title: 'No appraiser assigned',
                    description: 'Add at least one appraiser as an observer:',
                    loading: 'Loading appraisers...',
                    empty: 'No linked appraisers are available for this order.',
                    selectLabel: 'Appraiser',
                },
                handoverModal: {
                    title: 'Share annotations',
                    primaryButton: 'Share',
                    imageAlt: 'share',
                    makeAnnotationsVisible: 'Make all annotations on this draft visible to the appraiser',
                    requestNewDraft: 'Request a new draft based on the annotations',
                    infoText: 'You can still add, edit, and delete annotations on this draft. Your appraiser will be notified immediately.',
                },
                approvalModal: {
                    title: 'Approve draft',
                    primaryButton: 'Approve',
                    imageAlt: 'approve',
                    makeAnnotationsVisible: 'Make all annotations on this draft visible to the appraiser',
                    requestFinalizationWithAnnotations:
                        'Request finalization of the appraisal after the annotations have been incorporated',
                    requestFinalization: 'Request finalization of the appraisal',
                    infoText: 'After approval, you can no longer add, edit, or delete annotations on this draft.',
                    confirmationLabel: 'I confirm that I approve the draft for finalization.',
                },
                internalApprovalModal: {
                    title: 'Approve draft',
                    primaryButton: 'Approve',
                    imageAlt: 'approve',
                    fundApproval: 'Grant fund-side approval',
                    confirmationLabel: 'I confirm that I approve this draft.',
                },
            },
        },
    },
}
